export default __webpack_public_path__ + "static/7919-e28742f5048dbac1654afd2814b46e6c.jpg";